import { render, staticRenderFns } from "./LegalMentions.vue?vue&type=template&id=2ac86614"
import script from "./LegalMentions.vue?vue&type=script&lang=ts"
export * from "./LegalMentions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports